import { Component, EventEmitter, HostListener, Output, signal } from '@angular/core';
import {
  FormBuilder, 
  FormGroup, 
  ReactiveFormsModule, 
  Validators 
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { PasswordTooltipComponent } from '../password-tooltip/password-tooltip.component';
import { 
  hasUppercase,
  hasLowerCase,
  hasNumber,
  hasSpecialCharacter, 
} from '../../../utils/sharedFunctions';
import { of } from 'rxjs';

@Component({
  selector: 'app-sign-up-form',
  imports: [
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    MatCheckboxModule,
    MatIconModule,
    PasswordTooltipComponent,
  ],
  templateUrl: './sign-up-form.component.html',
  styleUrl: './sign-up-form.component.css'
})
export class SignUpFormComponent {
  signupForm: FormGroup;
  hidePassword = signal(true);
  hideConfirmPassword = signal(true);
  showTooltip: boolean = false;
  passCond1: boolean = false;
  passCond2: boolean = false;
  passCond3: boolean = false;
  passCond4: boolean = false;
  passCond5: boolean = false;
  
  @Output() showTermsEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() formSubmittedEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() signInEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  @HostListener('window:keyup')
  keyEvent() {
    this.handlePasswordCriteria();
  }

  constructor(private fb: FormBuilder) {
    this.signupForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(3)]],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [
          Validators.required, 
          Validators.minLength(6)
        ],
        this.validatePasswordCriteria.bind(this),
      ],
      confirm_password: ['', [
          Validators.required, 
          Validators.minLength(6), 
        ],
        this.passwordMatchValidator.bind(this)
      ],
      acceptTerms: [false, Validators.requiredTrue]
    });
  }

  clickPasswordEvent(event: MouseEvent) {
    this.hidePassword.set(!this.hidePassword());
    event.stopPropagation();
  }

  clickConfirmPassEvent(event: MouseEvent) {
    this.hideConfirmPassword.set(!this.hideConfirmPassword());
    event.stopPropagation();
  }

  onTermsClick() {
    this.showTermsEmitter.emit(true);
  }

  passwordMatchValidator() {
    const password = this.signupForm.get('password')?.value;
    const confirmPassword = this.signupForm.get('confirm_password')?.value;
    return of(password === confirmPassword ? null : { mismatch: true });
  }

  handlePasswordCriteria() {
    const userPassword = this.signupForm.get('password')?.value;
    this.passCond1 = userPassword?.length >= 8 ? true : false;
    this.passCond2 = hasNumber(userPassword) ? true : false;
    this.passCond3 = hasSpecialCharacter(userPassword) ? true : false;
    this.passCond4 = hasUppercase(userPassword) ? true : false;
    this.passCond5 = hasLowerCase(userPassword) ? true : false;
  }

  validatePasswordCriteria() {
    let validator = true;
    if (
      !this.passCond1 || !this.passCond2 || !this.passCond3 || 
      !this.passCond4 || !this.passCond5
    ) {
      validator = false;
    }
    return of(validator ? null : { criteriaFailed: true });
  }

  onSignInClick() {
    this.signInEmitter.emit(true);
  }

  onSubmit() {
    console.log('Form submitted', this.signupForm);
    if (this.signupForm.invalid) {
      this.signupForm.markAllAsTouched();
      return;
    }
    this.formSubmittedEmitter.emit(true);
  }
}
